import React from 'react';
import PhoneInput from 'react-phone-number-input';
// Use a compatible prop type for the country select component since
// 'react-phone-number-input' may not export CountrySelectComponentProps.
type CountrySelectComponentProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

// Custom input styled with Tailwind
const CustomInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  (props, ref) => (
    <input
      {...props}
      ref={ref}
      className="w-full bg-[#ceb0c0] text-[#621C43] rounded-lg p-2 placeholder-[#621C43] font-sans text-base focus:outline-none focus:ring-2 focus:ring-[#4A082D]"
    />
  ),
);

// Custom country select button styled with Tailwind
const CustomCountrySelect = React.forwardRef<HTMLButtonElement, CountrySelectComponentProps>(
  (props, ref) => (
    <button
      {...props}
      ref={ref}
      type="button"
      className="absolute left-2 top-1/2 transform -translate-y-1/2 rounded-md focus:outline-none"
    />
  ),
);

interface MyPhoneInputProps {
  value: string;
  onChange: (value: string | undefined) => void;
  country: string;
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
}

function MyPhoneInput({
  value,
  onChange,
  country,
  disabled = false,
  error = false,
  success = false,
}: MyPhoneInputProps) {
  return (
    <div className="relative w-full">
      <PhoneInput
        international
        defaultCountry="IN"
        value={value}
        onChange={onChange}
        disabled={disabled}
        inputComponent={CustomInput}
        countrySelectComponent={CustomCountrySelect}
        className={`w-full ${error ? 'border-red-500' : ''} ${success ? 'border-green-500' : ''}`}
      />
    </div>
  );
}

export default MyPhoneInput;
